module.exports = __webpack_public_path__ + "static/media/closePL.6b81dad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/museum/closePL.png
// module id = 1102
// module chunks = 0